{
  "add": "Hinzufügen",
  "addPeople": "Personen hinzufügen",
  "addTo": "Zu „{{group}}“ hinzufügen",
  "allowedBy": {
    "administrators": "Administration",
    "every_signed_in_person": "alle Angemeldeten",
    "item_curator": "kuratiert ein Element"
  },
  "alwaysLast": "immer zuletzt",
  "alwaysOnTop": "immer oben",
  "atTop": "Auf oberster Ebene",
  "blocks": {
    "dmw_core": "Eigenes Projekt von DMW",
    "not_deletable": "nicht löschbar",
    "project_not_active": "Projekt nicht aktiv"
  },
  "breadcrumb": "Wo Sie sind",
  "categories": {
    "agents": "Agenten",
    "content": "Inhalte",
    "curation": "Kuratierung",
    "inProjects": "In jedem Projekt, das diese Gruppe aufnimmt",
    "installation": "In der Installation",
    "management": "Verwaltung",
    "releases": "Datenveröffentlichungen"
  },
  "chips": {
    "curateEvery": "Kuratiert jede Art",
    "curateOne": "Kuratiert {{kind}}",
    "curateSome_one": "Kuratiert {{count}} Art",
    "curateSome_other": "Kuratiert {{count}} Arten",
    "everything": "Jede Installationsberechtigung",
    "everythingOf": "alles, was {{group}} hat",
    "inProjects": "in Projekten:",
    "offHere": "hier aus:",
    "onHere": "hier auch:"
  },
  "create": "Anlegen",
  "delete": "Löschen",
  "deleteExplained": "Ihre Mitglieder verlieren, was sie hier gibt.",
  "deleteInstallationExplained": "Ihre Mitglieder verlieren, was sie gibt, und jedes Projekt, das sie aufnimmt, verliert sie.",
  "deleteTitle": "„{{group}}“ löschen?",
  "done": {
    "changed": "„{{group}}“ gespeichert.",
    "excluded": "„{{group}}“ ist hier nicht mehr aufgenommen.",
    "grantOff": "„{{group}}“ darf nicht mehr: {{permission}}.",
    "grantOn": "„{{group}}“ darf jetzt: {{permission}}.",
    "grants": "Geändert, was „{{group}}“ erlaubt.",
    "included": "„{{group}}“ ist hier aufgenommen.",
    "memberAdded": "{{name}} ist in „{{group}}“.",
    "memberRemoved": "{{name}} ist nicht mehr in „{{group}}“.",
    "moved": "„{{group}}“ verschoben.",
    "overrides": "Geändert, was „{{group}}“ hier gibt."
  },
  "everyoneWithAccount": "alle mit Konto",
  "findPerson": "Person suchen",
  "fromInstallation": "Von der Installation",
  "giveOnlyOwn": "Sie können nur Berechtigungen vergeben, die Sie selbst haben; Kuratieren dürfen alle, die die Gruppe verwalten.",
  "group": "Gruppe",
  "groupGone": "Diese Gruppe gibt es nicht mehr.",
  "groupMenu": "Mehr zu „{{group}}“",
  "groups": "Gruppen",
  "included": {
    "given": "Gilt hier",
    "inherit": "Wie die Installation",
    "notGiven": "Gilt hier nicht",
    "off": "Hier aus",
    "on": "Hier an"
  },
  "includedHere": "hier aufgenommen",
  "inside": "Innerhalb von",
  "installationBadge": "Installation",
  "invite": {
    "addresses": "E-Mail-Adressen",
    "button": "Einladen",
    "joins": "Sie kommen in {{groups}}, sobald sie annehmen. Keine Freigabe nötig.",
    "joinsIn": "Sie kommen in „{{group}}“ in {{project}}, sobald sie annehmen. Keine Freigabe nötig.",
    "joinsNothing": "Sie erhalten ein Konto, sobald sie annehmen. Keine Freigabe nötig.",
    "people": "Personen einladen",
    "removeAddress": "{{address}} entfernen",
    "send_one": "{{count}} Einladung senden",
    "send_other": "{{count}} Einladungen senden",
    "title": "In „{{group}}“ einladen"
  },
  "itemCurator_one": "Kuratiert {{count}} Element",
  "itemCurator_other": "Kuratiert {{count}} Elemente",
  "kind": {"installation": "Gruppe der Installation", "project": "Gruppe dieses Projekts"},
  "kinds": {
    "every": "Jede Art",
    "save": "Speichern",
    "title": "Was „{{group}}“ kuratiert",
    "titleHere": "Was „{{group}}“ hier kuratiert"
  },
  "locked": "Hier nicht änderbar",
  "members": "Mitglieder",
  "membersInAdministration": "Ihre Mitglieder werden in der Administration verwaltet.",
  "moveAbove": "Verschieben über",
  "name": "Name",
  "newGroup": "Neue Gruppe",
  "newGroupButton": "+ Neue Gruppe",
  "newGroupItem": "Neue Gruppe …",
  "noMembers": "Noch niemand.",
  "nobody": "Niemand gefunden.",
  "panel": {
    "close": "Schließen",
    "curates": "Kuratiert {{kinds}}",
    "groupsHere": "Gruppen hier",
    "haveIt_one": "Gewährt durch {{groups}}",
    "haveIt_other": "Gewährt durch {{groups}}",
    "here": "{{group}}, hier",
    "inThisProject": "In diesem Projekt",
    "inactive": "Kann sich nicht anmelden",
    "managedByAdministrators": "Ändern kann diesen Zugriff die Administration.",
    "managedBy_one": "Ändern kann diesen Zugriff: {{names}}.",
    "managedBy_other": "Ändern können diesen Zugriff: {{names}}.",
    "no": "Nein:",
    "noGroup": "Hier in keiner Gruppe",
    "notOtherKinds_one": "nicht die andere Art",
    "notOtherKinds_other": "nicht die anderen {{count}} Arten",
    "yes": "Ja:"
  },
  "people": "Personen",
  "peopleCount_one": "{{count}} Person",
  "peopleCount_other": "{{count}} Personen",
  "permissions": {
    "change_installation": "Einstellungen der Installation ändern",
    "change_rules": "Regeln des Projekts ändern",
    "create_projects": "Projekte anlegen",
    "curate": "Kuratieren: übernehmen, zurückgeben, verwerfen",
    "delete_project": "Projekt löschen",
    "manage_accounts": "Konten und Gruppen unterhalb Ihrer höchsten Gruppe verwalten",
    "manage_people": "Personen und Gruppen unterhalb Ihrer höchsten Gruppe verwalten",
    "manage_server_keys": "Server-Schlüssel und Budgets verwalten",
    "propose": "Änderungen vorschlagen",
    "release": "Datenveröffentlichungen erstellen und publizieren",
    "restore_projects": "Gelöschte Projekte wiederherstellen und endgültig löschen",
    "server_keys": "Agenten mit den API-Schlüsseln des Servers",
    "view": "Ansehen, kommentieren und klonen"
  },
  "permissionsTitle": "Berechtigungen",
  "position_ordinal_few": "{{count}}. von {{total}}",
  "position_ordinal_one": "{{count}}. von {{total}}",
  "position_ordinal_other": "{{count}}. von {{total}}",
  "position_ordinal_two": "{{count}}. von {{total}}",
  "reason": {
    "confirm": "Einschalten",
    "serverKeys": "Warum darf „{{group}}“ Agenten mit den API-Schlüsseln des Servers ausführen?",
    "serverKeysHere": "Warum darf „{{group}}“ hier Agenten mit den API-Schlüsseln des Servers ausführen?"
  },
  "removeHere": "Aus diesem Projekt entfernen",
  "removeHereExplained": "Ihre Mitglieder verlieren, was sie hier gibt. Die Gruppe bleibt in der Installation.",
  "removeHereTitle": "„{{group}}“ aus diesem Projekt entfernen?",
  "removedGroup": "Eine entfernte Gruppe",
  "rename": "Umbenennen",
  "renameTitle": "„{{group}}“ umbenennen",
  "requests": {
    "adds": "gibt {{grants}}",
    "asks": "fragt „{{permission}}“ an",
    "decline": "Ablehnen",
    "otherGroups": "Andere Gruppen",
    "reason": "„{{reason}}“",
    "title": "Anfragen nach Zugriff"
  },
  "rule": "Jede Person darf, was eine ihrer Gruppen erlaubt; die Reihenfolge regelt nur, wer wen verwaltet: Wer verwalten darf, verwaltet die Gruppen unter der eigenen höchsten.",
  "save": "Speichern",
  "serverKeysHint": "Nur wer Server-Schlüssel verwaltet, vergibt das, mit Grund",
  "short": {
    "change_installation": "Einstellungen",
    "change_rules": "Regeln",
    "create_projects": "Projekte anlegen",
    "curate": "Kuratieren",
    "delete_project": "Löschen",
    "manage_accounts": "Konten",
    "manage_people": "Verwalten",
    "manage_server_keys": "Schlüssel-Budgets",
    "propose": "Vorschlagen",
    "release": "Datenveröffentlichungen",
    "restore_projects": "Gelöschte Projekte",
    "server_keys": "Server-Schlüssel",
    "view": "Ansehen"
  },
  "startsEmpty": "Noch nichts",
  "startsLike": "Beginnt mit dem, was diese Gruppe erlaubt",
  "systemGroups": {
    "administrators": "Administrierende",
    "contributors": "Mitwirkende",
    "curators": "Kuratierende",
    "everyone": "Alle",
    "project_administrators": "Administrierende",
    "readers": "Lesende"
  },
  "takeOut": "{{name}} aus „{{group}}“ nehmen",
  "undo": "Rückgängig",
  "via": "über {{group}}",
  "view": "Zeigen"
}
